import { Flex, Text, Box, Image } from "rebass/styled-components";
import { textWithImgStyles as styles } from "../lib/styles/landingStyles";

interface Props {
  title?: string;
  children: any;
  imgsrc: string;
  imgAlt?: string;
  imgRight?: boolean;
  imgLeft?: boolean;
  bgColor?: string;
  color?: string;
  showImgMobile?: boolean;
  height?: any;
}

function TextWithImg(props: Props) {
  const {
    title,
    children,
    imgsrc,
    imgAlt,
    imgRight,
    imgLeft,
    bgColor = "inuOrange",
    color = "samoyedWhite",
    showImgMobile = true,
    height
  } = props;

  const imgStyle = {
    ...styles.boxImg,
    ...(!showImgMobile && { display: ["none", "none", "inherit"] })
  };

  return (
    <Flex
      sx={{
        ...styles.flex,
        backgroundColor: bgColor,
        color: color,
        height: height
      }}
    >
      {imgRight || (imgRight === imgLeft) === undefined ? (
        <>
          <Box sx={styles.boxTextLeft}>
            {title && (
              <Text as="h2" sx={styles.title}>
                {title}
              </Text>
            )}
            {children}
          </Box>
          <Box sx={imgStyle}>
            <Box height={"100%"}>
              <Image sx={styles.img} src={imgsrc} alt={imgAlt || title} />
            </Box>
          </Box>
        </>
      ) : (
        <>
          <Box sx={imgStyle}>
            <Box height="100%" width="100%">
              <Image sx={styles.img} src={imgsrc} alt={imgAlt || title} />
            </Box>
          </Box>
          <Box sx={styles.boxTextRight}>
            {title && (
              <Text as="h2" sx={styles.title}>
                {title}
              </Text>
            )}
            {children}
          </Box>
        </>
      )}
    </Flex>
  );
}

export default TextWithImg;
